export class CustomPurchaseWindow {
  //IF THIS IS NULL, CAN BE PURCHASED ANYTIME IT IS VISIBLE
  public start: number;
  public end: number;
  public timeOnLastDay: string;
  constructor(start?: number, end?: number, timeOnLastDay?: string) {
    this.start = start == null ? null : start;
    this.end = end == null ? null : end;
    this.timeOnLastDay = timeOnLastDay == null ? null : timeOnLastDay;
  }

  toJSON() {
    return {
      start: this.start == null ? null : this.start,
      end: this.end == null ? null : this.end,
      timeOnLastDay: this.timeOnLastDay == null ? null : this.timeOnLastDay
    };
  }
}
